import React, { Component } from 'react';
import { RouteChildrenProps } from 'react-router';
import { Link } from 'react-router-dom';
import { Glyphicon, FormGroup, Button, InputGroup, FormControl } from 'react-bootstrap'
import { observer, inject } from 'mobx-react';
import ConfigurationStore from '../stores/ConfigurationStore';
import { INotificationType } from '../models/NotificationType';
import { NotificationTypeFieldGroup } from '../components/NotificationTypeFieldGroup'
import { AllStores } from '../stores';

interface INotificationTypeProps {
    configurationStore : ConfigurationStore;
}

type NotificationTypeState = {
    isEditing : boolean
}

type NotificationTypeProps = INotificationTypeProps & RouteChildrenProps<{ notificationTypeId : string}>;

@inject((allStores : AllStores) => {
    return {
      configurationStore: allStores.configurationStore as ConfigurationStore
    };
  })
@observer
class NotificationType extends Component<NotificationTypeProps, NotificationTypeState> {
    state = {
        isEditing: false
    };

    componentDidMount() {
        if(this.props.match)
            this.props.configurationStore.setCurrentNotificationId(parseInt(this.props.match.params.notificationTypeId, 10));
    }

    setIsEditing = (isEditing : boolean) => {
        this.setState({ isEditing });
    };

    render() {
        const { isEditing } = this.state;
        const { notificationType, isLoading } = this.props.configurationStore;
        const { name: title, addNewField, cancelAdd, fields } = notificationType as INotificationType;
        if(isLoading || fields === void 0) 
            return <p><em>Loading...</em></p>;

        const type = notificationType as INotificationType;
        return (
            <form className='notification-types-form'>
                <h1>Notification Type: {title}</h1>
                <Link to={'/notification-type/'} className="mr-5">
                    <Glyphicon glyph="arrow-left" /> All Notification Types
                </Link>
                <Button bsStyle="link" onClick={addNewField} disabled={isEditing}>
                    <Glyphicon glyph="plus"/> Add new field?
                </Button>
                <hr></hr>
                <div>
                    <FormGroup>
                        {type.fields.map((field) => {
                            return (
                                <NotificationTypeFieldGroup 
                                    key={field.id} 
                                    field={field} 
                                    configurationStore={this.props.configurationStore}
                                    disabled={isEditing}
                                    setIsEditing={this.setIsEditing}
                                    cancelAdd={cancelAdd}
                                    />
                            )
                        })}
                    </FormGroup>
                </div>
            </form>
        );
    }
}

export { NotificationType };